<template lang="pug">
  .table-data(:style="columnStyle",@mouseover="$emit('mouseover')")
    slot
</template>

<script>
export default {
  name: 'v-td',
  props: {
    columnStyle: {
      type: Object,
      default: () => {
        return {}
      }
    }
  }
}
</script>

<style scoped lang="sass">
  .table-data
    line-height: 28px
  .table-right .table-data
    text-align: center
</style>



// WEBPACK FOOTER //
// VTd.vue?1cd61b2f